import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/SoftDeletableEntityProperties";

export interface ICaseProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    enquiryId: IPropertyInfoMetadata;
    editedByStaff: IPropertyInfoMetadata;
    receivedDate: IPropertyInfoMetadata;
    localAuthorityId: IPropertyInfoMetadata;
    localAuthorityContractId: IPropertyInfoMetadata;
    callCentreContactSourceLookupItemId: IPropertyInfoMetadata;
    callCentreContactSourceUrn: IPropertyInfoMetadata;
    caseReference: IPropertyInfoMetadata;
    caseReferenceSuffix1: IPropertyInfoMetadata;
    caseReferenceSuffix2: IPropertyInfoMetadata;
    caseReferenceFull: IPropertyInfoMetadata;
    caseManagerStaffMemberId: IPropertyInfoMetadata;
    initialEnquiryMadeByLookupItemId: IPropertyInfoMetadata;
    titleLookupItemId: IPropertyInfoMetadata;
    forename: IPropertyInfoMetadata;
    surname: IPropertyInfoMetadata;
    address1: IPropertyInfoMetadata;
    address2: IPropertyInfoMetadata;
    town: IPropertyInfoMetadata;
    postcode: IPropertyInfoMetadata;
    emailAddress: IPropertyInfoMetadata;
    emailAddressVerified: IPropertyInfoMetadata;
    telephoneHome: IPropertyInfoMetadata;
    telephoneWork: IPropertyInfoMetadata;
    telephoneMobile: IPropertyInfoMetadata;
    typeLookupItemId: IPropertyInfoMetadata;
    primarySpecialNeedsDiagnosisLookupItemId: IPropertyInfoMetadata;
    primarySpecialNeedsDiagnosisOther: IPropertyInfoMetadata;
    referralReasonLookupItemId: IPropertyInfoMetadata;
    referralReasonOther: IPropertyInfoMetadata;
    ehcpContent: IPropertyInfoMetadata;
    secondarySpecialNeedsDiagnosisLookupItemId: IPropertyInfoMetadata;
    secondarySpecialNeedsDiagnosisOther: IPropertyInfoMetadata;
    callback: IPropertyInfoMetadata;
    customerSourceLookupItemId: IPropertyInfoMetadata;
    customerSourceOther: IPropertyInfoMetadata;
    sendiassContacted: IPropertyInfoMetadata;
    cypForenames: IPropertyInfoMetadata;
    cypSurname: IPropertyInfoMetadata;
    cypGenderLookupItemId: IPropertyInfoMetadata;
    cypBirthDate: IPropertyInfoMetadata;
    parentTitleLookupItemId: IPropertyInfoMetadata;
    parentForenames: IPropertyInfoMetadata;
    parentSurname: IPropertyInfoMetadata;
    parentAddressee: IPropertyInfoMetadata;
    decisionLetterDate: IPropertyInfoMetadata;
    outcomeSought: IPropertyInfoMetadata;
    initialContactDate: IPropertyInfoMetadata;
    appealStatusLookupItemId: IPropertyInfoMetadata;
    appealStatusOther: IPropertyInfoMetadata;
    appealDate: IPropertyInfoMetadata;
    parentHasAdditionalNeeds: IPropertyInfoMetadata;
    experiencedMediatorOrLocalAuthorityOfficerRequired: IPropertyInfoMetadata;
    safeguardingConcern: IPropertyInfoMetadata;
    school: IPropertyInfoMetadata;
    contactNotes: IPropertyInfoMetadata;
    initialEnquiryDate: IPropertyInfoMetadata;
    callbackDate: IPropertyInfoMetadata;
    callBackTime: IPropertyInfoMetadata;
    isOutlookReminder: IPropertyInfoMetadata;
    clientFolder: IPropertyInfoMetadata;
    optionSelectedLookupItemId: IPropertyInfoMetadata;
    currentActivity: IPropertyInfoMetadata;
    maCompletedDate: IPropertyInfoMetadata;
    mediationAdviserStaffMemberId: IPropertyInfoMetadata;
    caseStatus: IPropertyInfoMetadata;
    closedDate: IPropertyInfoMetadata;
    outcomeLookupItemId: IPropertyInfoMetadata;
    outcomeNotes: IPropertyInfoMetadata;
    cancellationChargeCode: IPropertyInfoMetadata;
    part1Only: IPropertyInfoMetadata;
    part1RequestedDate: IPropertyInfoMetadata;
    part1SentDate: IPropertyInfoMetadata;
    part2SentDate: IPropertyInfoMetadata;
    part3SentDate: IPropertyInfoMetadata;
    sendMaPart3: IPropertyInfoMetadata;
    mediationType: IPropertyInfoMetadata;
    isMediationTypeHealth: IPropertyInfoMetadata;
    isMediationTypeSocial: IPropertyInfoMetadata;
    isMediationTypeEducation: IPropertyInfoMetadata;
    disagreementResolutionTypeLookupItemId: IPropertyInfoMetadata;
    disagreementResolutionTypeOther: IPropertyInfoMetadata;
    isCypOver16: IPropertyInfoMetadata;
    spokenToCyp: IPropertyInfoMetadata;
    mediationRejectionReasonLookupItemId: IPropertyInfoMetadata;
    mediationRejectionReasonOther: IPropertyInfoMetadata;
    mainConcern: IPropertyInfoMetadata;
    accessibility: IPropertyInfoMetadata;
    cypNoContactReason: IPropertyInfoMetadata;
    isVenueConfirmed: IPropertyInfoMetadata;
    isContractSigned: IPropertyInfoMetadata;
    cancellationReason: IPropertyInfoMetadata;
    cancellationPartyLookupItemId: IPropertyInfoMetadata;
    cancellationNotes: IPropertyInfoMetadata;
    cancellationDate: IPropertyInfoMetadata;
    mediationAdviceResponseLookupItemId: IPropertyInfoMetadata;
    mediationAdviceComment: IPropertyInfoMetadata;
    decisionOutcomeLookupItemId: IPropertyInfoMetadata;
    medFbUpdated: IPropertyInfoMetadata;
    doesSencoParentAgree: IPropertyInfoMetadata;
    sencoName: IPropertyInfoMetadata;
    sencoEmailAddress: IPropertyInfoMetadata;
    isSencoMediationDateOk: IPropertyInfoMetadata;
    isFinalEhcp: IPropertyInfoMetadata;
    isFirstFinalEhcp: IPropertyInfoMetadata;
    hadAmendedEhcpFollowingPhaseTransfer: IPropertyInfoMetadata;
    isUrgent: IPropertyInfoMetadata;
    hadAnnualReview: IPropertyInfoMetadata;
    alertReasonLookupItemId: IPropertyInfoMetadata;
    alertDate: IPropertyInfoMetadata;
    schedulingStatus: IPropertyInfoMetadata;
    listDescription: IPropertyInfoMetadata;
    notifyAtEndOfProcess: IPropertyInfoMetadata;
    useAutomatedMediationDateProcess: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    enquiry: IPropertyInfoMetadata;
    localAuthority: IPropertyInfoMetadata;
    localAuthorityContract: IPropertyInfoMetadata;
    caseManagerStaffMember: IPropertyInfoMetadata;
    mediationAdviserStaffMember: IPropertyInfoMetadata;
    caseReferral: IPropertyInfoMetadata;
    alertReasonLookupItem: IPropertyInfoMetadata;
    appealStatusLookupItem: IPropertyInfoMetadata;
    callCentreContactSourceLookupItem: IPropertyInfoMetadata;
    cancellationPartyLookupItem: IPropertyInfoMetadata;
    customerSourceLookupItem: IPropertyInfoMetadata;
    cypGenderLookupItem: IPropertyInfoMetadata;
    decisionOutcomeLookupItem: IPropertyInfoMetadata;
    disagreementResolutionTypeLookupItem: IPropertyInfoMetadata;
    initialEnquiryMadeByLookupItem: IPropertyInfoMetadata;
    mediationAdviceResponseLookupItem: IPropertyInfoMetadata;
    mediationRejectionReasonLookupItem: IPropertyInfoMetadata;
    optionSelectedLookupItem: IPropertyInfoMetadata;
    outcomeLookupItem: IPropertyInfoMetadata;
    parentTitleLookupItem: IPropertyInfoMetadata;
    primarySpecialNeedsDiagnosisLookupItem: IPropertyInfoMetadata;
    referralReasonLookupItem: IPropertyInfoMetadata;
    secondarySpecialNeedsDiagnosisLookupItem: IPropertyInfoMetadata;
    titleLookupItem: IPropertyInfoMetadata;
    typeLookupItem: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Collection Properties

    caseAdditionalAttendees: IPropertyInfoMetadata;
    caseAuthenticationLogItems: IPropertyInfoMetadata;
    caseCancellationsAndPostponements: IPropertyInfoMetadata;
    caseEmailClaims: IPropertyInfoMetadata;
    caseEmails: IPropertyInfoMetadata;
    caseInvoiceItems: IPropertyInfoMetadata;
    caseMeetingRequests: IPropertyInfoMetadata;
    caseMeetings: IPropertyInfoMetadata;
    caseNotes: IPropertyInfoMetadata;
    caseScheduleQueueItems: IPropertyInfoMetadata;
    clientSatisfactionQuestionnaires: IPropertyInfoMetadata;
    mediatorEvaluationForms: IPropertyInfoMetadata;

    // #endregion

}

export const Case: ITypeInfoMetadata<ICaseProperties> = {
    attributes: [
        {
            id: "{8A8FCF9D-AB26-43CC-B6DA-0383900EBDCC}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "Case",
            nameFriendly: "Case",
            namePlural: "Cases",
            namePluralFriendly: "Cases",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "GlobalMediation.Data.Entities.Case, GlobalMediation.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "Case",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        enquiryId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Enquiry"
                },
                {
                    entityDescriptionProperty: "ReferenceNumber",
                    entityName: "Enquiry",
                    entityNameFriendly: "Enquiry",
                    entityNamePlural: "Enquiries",
                    entityNamePluralFriendly: "Enquiries",
                    foreignEntityAlias: "Cases",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EnquiryId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        editedByStaff: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Edited by Staff"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EditedByStaff",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        receivedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Received Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+ReceivedDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareReadOnlyAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ReceivedDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Local Authority"
                },
                {
                    entityDescriptionProperty: "Name",
                    entityName: "LocalAuthority",
                    entityNameFriendly: "Local Authority",
                    entityNamePlural: "LocalAuthorities",
                    entityNamePluralFriendly: "Local Authorities",
                    foreignEntityAlias: "Cases",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+LocalAuthorityIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 3
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityContractId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Local Authority Contract"
                },
                {
                    entityDescriptionProperty: "Description",
                    entityName: "LocalAuthorityContract",
                    entityNameFriendly: "Local Authority Contract",
                    entityNamePlural: "LocalAuthorityContracts",
                    entityNamePluralFriendly: "Local Authority Contracts",
                    foreignEntityAlias: "Cases",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 4
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityContractId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        callCentreContactSourceLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Call Centre Contact Source"
                },
                {
                    foreignEntityAlias: "CasesByCallCentreContactSource",
                    typeDescription: "Call Centre Contact Sources",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 5
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CallCentreContactSourceLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        callCentreContactSourceUrn: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Call Centre Contact Source Urn"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 6
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CallCentreContactSourceUrn",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseReference: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case Reference"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareReadOnlyAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 7
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseReference",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseReferenceSuffix1: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Case Suffix 1"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case Suffix 1"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 8
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 16,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseReferenceSuffix1",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseReferenceSuffix2: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Case Suffix 2"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case Suffix 2"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 9
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 16,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseReferenceSuffix2",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseManagerStaffMemberId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Case Manager"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case Manager"
                },
                {
                    entityDescriptionProperty: "FullName",
                    entityName: "StaffMember",
                    entityNameFriendly: "Staff Member",
                    entityNamePlural: "StaffMembers",
                    entityNamePluralFriendly: "Staff Members",
                    foreignEntityAlias: "CasesByCaseManagerStaffMember",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CaseManagerStaffMemberIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 11
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseManagerStaffMemberId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        initialEnquiryMadeByLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Initial Enquiry Made By"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Initial Enquiry Made By"
                },
                {
                    foreignEntityAlias: "CasesByInitialEnquiryMadeBy",
                    typeDescription: "GM Case Enquirers",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 12
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "InitialEnquiryMadeByLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        titleLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Title"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Title"
                },
                {
                    foreignEntityAlias: "CasesByTitle",
                    typeDescription: "GM Person Titles",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        propertyName: "EditedByStaff",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: true,
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+TitleLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 13
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TitleLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        forename: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Forename"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Forename"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+ForenameMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 14
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Forename",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        surname: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Surname"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Surname"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+SurnameMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 15
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Surname",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        address1: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Address 1"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Address 1"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+Address1MandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 16
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Address1",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        address2: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Address 2"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Address 2"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 17
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Address2",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        town: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Town"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Town"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+TownMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 18
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Town",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        postcode: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Postcode"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Postcode"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+PostcodeMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 19
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Postcode",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        emailAddress: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Email Address"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Email Address"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+EmailAddressMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 20
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EmailAddress",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        emailAddressVerified: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Email Address Verified?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 21
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EmailAddressVerified",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        telephoneHome: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Telephone (Home)"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Telephone (Home)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+TelephoneHomeMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 22
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TelephoneHome",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        telephoneWork: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Telephone (Work)"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Telephone (Work)"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 23
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TelephoneWork",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        telephoneMobile: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Telephone (Mobile)"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Telephone (Mobile)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+TelephoneMobileMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 24
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TelephoneMobile",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        typeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Type"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Type"
                },
                {
                    foreignEntityAlias: "CasesByType",
                    typeDescription: "GM Case Types",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+TypeLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 25
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        primarySpecialNeedsDiagnosisLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Primary SN Diag"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Primary SN Diag"
                },
                {
                    foreignEntityAlias: "CasesByPrimarySpecialNeedsDiagnosis",
                    typeDescription: "GM Special Needs Diagnoses",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+PrimarySpecialNeedsDiagnosisLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 26
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PrimarySpecialNeedsDiagnosisLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        primarySpecialNeedsDiagnosisOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Primary SN Diag. (Other)"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "PrimarySpecialNeedsDiagnosisLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "a5ef2ae2-f87e-4340-87dc-6f5f634d0bee",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                propertyName: "PrimarySpecialNeedsDiagnosisLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "bfe1c021-80a2-4cbd-b892-6ec8a981b978",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                propertyName: "PrimarySpecialNeedsDiagnosisLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "b22dfb69-fdb6-4d50-b172-9d49b34a249a",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.OrEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+PrimarySpecialNeedsDiagnosisOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 27
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PrimarySpecialNeedsDiagnosisOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        referralReasonLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Referral Reason"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Referral Reason"
                },
                {
                    foreignEntityAlias: "CasesByReferralReason",
                    typeDescription: "GM Referral Reasons",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 28
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ReferralReasonLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        referralReasonOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Referral Reason (Other)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+ReferralReasonOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "ReferralReasonLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "739a1ce8-36e8-4973-b28b-a084b3ed87b5",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+ReferralReasonOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 29
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ReferralReasonOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        ehcpContent: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "EHCP Content"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "EHCP Content"
                },
                {
                    evaluator: {
                        propertyName: "EditedByStaff",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: true,
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+EhcpContentMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "ReferralReasonLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "13625dee-7952-4bb8-9f04-d725b035a904",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+EhcpContentRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 30
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EhcpContent",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        secondarySpecialNeedsDiagnosisLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Secondary SN Diag"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Secondary SN Diag"
                },
                {
                    foreignEntityAlias: "CasesBySecondarySpecialNeedsDiagnosis",
                    typeDescription: "GM Special Needs Diagnoses",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 31
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SecondarySpecialNeedsDiagnosisLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        secondarySpecialNeedsDiagnosisOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Secondary SN Diag. (Other)"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "SecondarySpecialNeedsDiagnosisLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "a5ef2ae2-f87e-4340-87dc-6f5f634d0bee",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                propertyName: "SecondarySpecialNeedsDiagnosisLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "bfe1c021-80a2-4cbd-b892-6ec8a981b978",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                propertyName: "SecondarySpecialNeedsDiagnosisLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "b22dfb69-fdb6-4d50-b172-9d49b34a249a",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.OrEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+SecondarySpecialNeedsDiagnosisOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 32
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SecondarySpecialNeedsDiagnosisOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        callback: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Callback"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Callback"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 33
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Callback",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        customerSourceLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "How Heard"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "How Heard"
                },
                {
                    foreignEntityAlias: "CasesByCustomerSource",
                    typeDescription: "GM Customer Sources",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 34
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CustomerSourceLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        customerSourceOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "How Heard (Other)"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "How Heard (Other)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CustomerSourceOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "CustomerSourceLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "acd84ea3-318a-47e7-a469-e2ada83a2fdd",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CustomerSourceOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 35
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CustomerSourceOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        sendiassContacted: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "SENDIASS Contacted"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "SENDIASS Contacted"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 36
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SendiassContacted",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cypForenames: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "CYP Forenames"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "CYP Forenames"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CypForenamesMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 37
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CypForenames",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cypSurname: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "CYP Surname"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CypSurnameMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 38
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CypSurname",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cypGenderLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "CYP Gender"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "CYP Gender"
                },
                {
                    foreignEntityAlias: "CasesByCypGender",
                    typeDescription: "GM CYP Genders",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 39
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CypGenderLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cypBirthDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "CYP Birth Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "CYP Birth Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CypBirthDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 40
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CypBirthDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        parentTitleLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Parent Title"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Parent Title"
                },
                {
                    foreignEntityAlias: "CasesByParentTitle",
                    typeDescription: "GM Person Titles",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 41
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ParentTitleLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        parentForenames: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Parent Forenames"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Parent Forenames"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+ParentForenamesMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 42
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ParentForenames",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        parentSurname: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Parent Surname"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Parent Surname"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+ParentSurnameMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 43
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ParentSurname",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        parentAddressee: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Parent Addressee"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Parent Addressee"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+ParentAddresseeMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 44
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ParentAddressee",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        decisionLetterDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Decision Letter Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Decision Letter Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+DecisionLetterDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 45
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DecisionLetterDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        outcomeSought: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Outcome Sought"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Outcome Sought"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+OutcomeSoughtMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 46
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OutcomeSought",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        initialContactDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Initial Contact Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Initial Contact Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 47
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "InitialContactDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        appealStatusLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Appeal Status"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Appeal Status"
                },
                {
                    foreignEntityAlias: "CasesByAppealStatus",
                    typeDescription: "GM Appeal Statuses",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 48
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AppealStatusLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        appealStatusOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Appeal Status (Other)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+AppealStatusOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "AppealStatusLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "cb20048f-7517-4d80-af07-1582c7d99c64",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+AppealStatusOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 49
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AppealStatusOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        appealDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Appeal Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Appeal Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 50
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AppealDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        parentHasAdditionalNeeds: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Parent has Additional Needs?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Parent has Additional Needs?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 51
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ParentHasAdditionalNeeds",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        experiencedMediatorOrLocalAuthorityOfficerRequired: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Experienced Mediator / LA Officer Required?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 52
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ExperiencedMediatorOrLocalAuthorityOfficerRequired",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        safeguardingConcern: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Safeguarding Concern?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 53
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SafeguardingConcern",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        school: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "School"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "School"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 54
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "School",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        contactNotes: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Contact Notes"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Contact Notes"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 55
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ContactNotes",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        initialEnquiryDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Initial Enquiry Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Initial Enquiry Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+InitialEnquiryDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 56
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "InitialEnquiryDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        callbackDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Callback Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Callback Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 57
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CallbackDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        callBackTime: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "CallBack Time"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "CallBack Time"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 58
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CallBackTime",
            propertyTypeId: "System.Nullable`1[[System.TimeOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isOutlookReminder: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Outlook Reminder?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Outlook Reminder?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 59
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsOutlookReminder",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        clientFolder: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Client Folder"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Client Folder"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareReadOnlyAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 60
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ClientFolder",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        optionSelectedLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Option Selected"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Option Selected"
                },
                {
                    foreignEntityAlias: "CasesByOptionSelected",
                    typeDescription: "GM Case Options",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 61
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OptionSelectedLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        currentActivity: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Current Activity"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Current Activity"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 62
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CurrentActivity",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        maCompletedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "MA Completed Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "MA Completed Date"
                },
                {
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "EditedByStaff",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: true,
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                evaluators: [
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "6dd21766-ce24-4b33-812e-3156d259d030",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "9b37dcd3-b4e2-4487-a590-ac73807c4c6d",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "413fab4b-6a84-4f4b-8ad9-5e2e3c3cc4b6",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "5df4df8d-a67d-4a64-b034-2cbc5ba31b8a",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "529e50c9-5625-485e-92ed-972a3f42bfa2",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "23dda707-e02e-46f1-85bf-9d6a5c90d14b",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "1589d5df-b04b-489b-8fd4-b642fd02f224",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "a9e8bc7a-6d42-4c4b-94e0-3fc0b2cb40ee",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    }
                                ],
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.OrEvaluator, SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.AndEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+MaCompletedDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 63
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MaCompletedDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationAdviserStaffMemberId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Mediation Adviser"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Adviser"
                },
                {
                    entityDescriptionProperty: "FullName",
                    entityName: "StaffMember",
                    entityNameFriendly: "Staff Member",
                    entityNamePlural: "StaffMembers",
                    entityNamePluralFriendly: "Staff Members",
                    foreignEntityAlias: "CasesByMediationAdviserStaffMember",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "EditedByStaff",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: true,
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                evaluators: [
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "6dd21766-ce24-4b33-812e-3156d259d030",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "9b37dcd3-b4e2-4487-a590-ac73807c4c6d",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "413fab4b-6a84-4f4b-8ad9-5e2e3c3cc4b6",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "5df4df8d-a67d-4a64-b034-2cbc5ba31b8a",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "529e50c9-5625-485e-92ed-972a3f42bfa2",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "23dda707-e02e-46f1-85bf-9d6a5c90d14b",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "1589d5df-b04b-489b-8fd4-b642fd02f224",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "a9e8bc7a-6d42-4c4b-94e0-3fc0b2cb40ee",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    }
                                ],
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.OrEvaluator, SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.AndEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+MediationAdviserStaffMemberIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 64
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationAdviserStaffMemberId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseStatus: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Case Status"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case Status"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 65
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseStatus",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        closedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Closed Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Closed Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 66
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ClosedDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        outcomeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Outcome"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Outcome"
                },
                {
                    foreignEntityAlias: "CasesByOutcome",
                    typeDescription: "GM Case Outcomes",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 67
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OutcomeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        outcomeNotes: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Outcome Notes"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Outcome Notes"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 68
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OutcomeNotes",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationChargeCode: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Cancellation Charge Code"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Cancellation Charge Code"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 69
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationChargeCode",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        part1Only: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Part 1 Only?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Part 1 Only?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 70
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Part1Only",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        part1RequestedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Part 1 Requested Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Part 1 Requested Date"
                },
                {
                    helpText: "If you are asked to send a Mediation Certificate a day or more after giving Mediation Advice, please complete Part 1 Requested.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "EditedByStaff",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: true,
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                evaluators: [
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "6dd21766-ce24-4b33-812e-3156d259d030",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "5df4df8d-a67d-4a64-b034-2cbc5ba31b8a",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "529e50c9-5625-485e-92ed-972a3f42bfa2",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    },
                                    {
                                        propertyName: "OptionSelectedLookupItemId",
                                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                        propertyValue: "23dda707-e02e-46f1-85bf-9d6a5c90d14b",
                                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                    }
                                ],
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.OrEvaluator, SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.AndEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+Part1RequestedDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 71
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Part1RequestedDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        part1SentDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Part 1 Sent Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Part 1 Sent Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 72
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Part1SentDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        part2SentDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Part 2 Sent Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Part 2 Sent Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 73
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Part2SentDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        part3SentDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Part 3 Sen tDate"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Part 3 Sen tDate"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 74
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Part3SentDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        sendMaPart3: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Send MA Part 3"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Send MA Part 3"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 75
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SendMaPart3",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationType: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Mediation Type"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Type"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 76
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationType",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isMediationTypeHealth: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Mediation Type Health?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Mediation Type Health?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 77
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsMediationTypeHealth",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isMediationTypeSocial: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Mediation Type Social?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Mediation Type Social?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 78
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsMediationTypeSocial",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isMediationTypeEducation: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Mediation Type Education?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Mediation Type Education?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 79
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsMediationTypeEducation",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        disagreementResolutionTypeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "DR Type"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "DR Type"
                },
                {
                    foreignEntityAlias: "CasesByDisagreementResolutionType",
                    typeDescription: "GM Disagreement Resolution Types",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "TypeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "aeff81a2-77a9-4fb3-84c3-b2ccc2336cfb",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+DisagreementResolutionTypeLookupItemIdRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 80
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DisagreementResolutionTypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        disagreementResolutionTypeOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "DR Type (Other)"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "DR Type (Other)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+DisagreementResolutionTypeOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "TypeLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "aeff81a2-77a9-4fb3-84c3-b2ccc2336cfb",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                propertyName: "DisagreementResolutionTypeLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "be702a51-f806-4224-8228-bcfed08e7494",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.AndEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+DisagreementResolutionTypeOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 81
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DisagreementResolutionTypeOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isCypOver16: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is CYP Over 16?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is CYP Over 16?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareReadOnlyAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 82
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsCypOver16",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        spokenToCyp: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Spoken to CYP?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Spoken to CYP?"
                },
                {
                    evaluator: {
                        propertyName: "EditedByStaff",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: true,
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+SpokenToCypMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "IsCypOver16",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: true,
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+SpokenToCypRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 83
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SpokenToCyp",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationRejectionReasonLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Reason Mediation Rejected"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Reason Mediation Rejected"
                },
                {
                    foreignEntityAlias: "CasesByMediationRejectionReason",
                    typeDescription: "GM Mediation Rejection Reasons",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 84
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationRejectionReasonLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationRejectionReasonOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Reason Mediation Rejected (Other)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+MediationRejectionReasonOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "MediationRejectionReasonLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "9083800c-2b52-4087-8501-6c5aa72d55ba",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+MediationRejectionReasonOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 85
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationRejectionReasonOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mainConcern: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Main Concern"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Main Concern"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+MainConcernMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 86
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MainConcern",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        accessibility: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Accessibility"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Accessibility"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 87
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Accessibility",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cypNoContactReason: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "CYP No Contact Reason"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "CYP No Contact Reason"
                },
                {
                    evaluator: {
                        propertyName: "EditedByStaff",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: true,
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CypNoContactReasonMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "IsCypOver16",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: true,
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                evaluator: {
                                    propertyName: "SpokenToCyp",
                                    comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                    propertyValue: true,
                                    $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Boolean, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                                },
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.NotEvaluator, SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.AndEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+CypNoContactReasonRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 88
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CypNoContactReason",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isVenueConfirmed: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Venue Confirmed?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Venue Confirmed?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 89
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsVenueConfirmed",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isContractSigned: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Contract Signed?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Contract Signed?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 90
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsContractSigned",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationReason: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Cancellation Reason"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Cancellation Reason"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 91
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationReason",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationPartyLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Cancellation Party"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Cancellation Party"
                },
                {
                    foreignEntityAlias: "CasesByCancellationParty",
                    typeDescription: "GM Case Cancellation Parties",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 92
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationPartyLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationNotes: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Cancellation Notes"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Cancellation Notes"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 93
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationNotes",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Cancellation Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Cancellation Date"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 94
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationAdviceResponseLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "MA Response"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Are you satisfied with the service you have received today?"
                },
                {
                    foreignEntityAlias: "CasesByMediationAdviceResponse",
                    typeDescription: "GM Mediation Advice Responses",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 95
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationAdviceResponseLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationAdviceComment: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "MA Comment"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "MA Comment"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 96
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationAdviceComment",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        decisionOutcomeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Decision Outcome"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Decision Outcome"
                },
                {
                    foreignEntityAlias: "CasesByDecisionOutcome",
                    typeDescription: "GM Case Decision Outcomes",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 97
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DecisionOutcomeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        medFbUpdated: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Med FB Updated"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Med FB Updated"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 98
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MedFbUpdated",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        doesSencoParentAgree: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Does Senco Parent Agree?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Does Senco Parent Agree?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 99
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DoesSencoParentAgree",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        sencoName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Senco Name"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Senco Name"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 100
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SencoName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        sencoEmailAddress: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Senco Email Address"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Senco Email Address"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 101
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SencoEmailAddress",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isSencoMediationDateOk: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Senco Mediation Date OK?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Senco Mediation Date OK?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 102
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsSencoMediationDateOk",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isFinalEhcp: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Final EHCP?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Final EHCP?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 103
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsFinalEhcp",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isFirstFinalEhcp: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is First Final EHCP?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 104
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsFirstFinalEhcp",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        hadAmendedEhcpFollowingPhaseTransfer: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Had Amended EHCP Following Phase Transfer?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 105
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HadAmendedEhcpFollowingPhaseTransfer",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        isUrgent: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Is Urgent?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Is Urgent?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 106
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "IsUrgent",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        hadAnnualReview: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Had Annual Review?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 107
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HadAnnualReview",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        alertReasonLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Alert Reason"
                },
                {
                    foreignEntityAlias: "CasesByAlertReason",
                    typeDescription: "GM Case Alert Reasons",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 108
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AlertReasonLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        alertDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Alert Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+AlertDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "AlertReasonLookupItemId",
                        comparerId: "b1077685-1c05-4865-b95d-cf7542071813",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Object, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.Case+AlertDateRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 109
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AlertDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        schedulingStatus: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Scheduling Status"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 110
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SchedulingStatus",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        listDescription: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "List Description"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 111
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ListDescription",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        notifyAtEndOfProcess: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Notify at End of Process?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 112
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "NotifyAtEndOfProcess",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        useAutomatedMediationDateProcess: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Use Automated Mediation Date Process?"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 113
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "UseAutomatedMediationDateProcess",
            propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        alertReasonLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AlertReasonLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        appealStatusLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AppealStatusLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        callCentreContactSourceLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CallCentreContactSourceLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationPartyLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationPartyLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseReferenceFull: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case Reference (Full)"
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseReferenceFull",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseAdditionalAttendees: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseAdditionalAttendees",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseAdditionalAttendee, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseAuthenticationLogItems: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseAuthenticationLogItems",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseAuthenticationLogItem, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseCancellationsAndPostponements: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseCancellationsAndPostponements",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseEmailClaims: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseEmailClaims",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseEmailClaim, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseEmails: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseEmails",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseEmail, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseInvoiceItems: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseInvoiceItems",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseInvoiceItem, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseManagerStaffMember: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseManagerStaffMember",
            propertyTypeId: "GlobalMediation.Data.Entities.StaffMember, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseMeetingRequests: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseMeetingRequests",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseMeetingRequest, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseMeetings: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseMeetings",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseMeeting, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseNotes: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseNotes",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseNote, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseReferral: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseReferral",
            propertyTypeId: "GlobalMediation.Data.Entities.CaseReferral, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseScheduleQueueItems: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseScheduleQueueItems",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseScheduleQueueItem, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        clientSatisfactionQuestionnaires: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ClientSatisfactionQuestionnaires",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.ClientSatisfactionQuestionnaire, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        customerSourceLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CustomerSourceLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cypGenderLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CypGenderLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        decisionOutcomeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DecisionOutcomeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        disagreementResolutionTypeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "DisagreementResolutionTypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        enquiry: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Enquiry",
            propertyTypeId: "GlobalMediation.Data.Entities.Enquiry, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        initialEnquiryMadeByLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "InitialEnquiryMadeByLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthority: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthority",
            propertyTypeId: "GlobalMediation.Data.Entities.LocalAuthority, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityContract: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityContract",
            propertyTypeId: "GlobalMediation.Data.Entities.LocalAuthorityContract, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationAdviceResponseLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationAdviceResponseLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationAdviserStaffMember: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationAdviserStaffMember",
            propertyTypeId: "GlobalMediation.Data.Entities.StaffMember, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationRejectionReasonLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationRejectionReasonLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediatorEvaluationForms: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediatorEvaluationForms",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        optionSelectedLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OptionSelectedLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        outcomeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "OutcomeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        parentTitleLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ParentTitleLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        primarySpecialNeedsDiagnosisLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PrimarySpecialNeedsDiagnosisLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        referralReasonLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ReferralReasonLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        secondarySpecialNeedsDiagnosisLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "SecondarySpecialNeedsDiagnosisLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        titleLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TitleLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        typeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "GlobalMediation.Data.Entities.Case, GlobalMediation.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

